












export default {
  name: 'transition-height',
  props: {
    animatedClass: String
  },
  computed: {
    animatedClasses: function () {
      if (!!this.animatedClass) {
        const componentAnimatedClass = 'transition-height--animated';

        const enterClassSuffix = '-enter';
        const enterActiveClassSuffix = '-enter-active';
        const enterToClassSuffix = '-enter-to';

        const leaveClassSuffix = '-leave';
        const leaveActiveClassSuffix = '-leave-active';
        const leaveToClassSuffix = '-leave-to';

        return {
          enterClass: `${ componentAnimatedClass }${ enterClassSuffix } ${ this.animatedClass }${ enterClassSuffix }`,
          enterActiveClass: `${ componentAnimatedClass }${ enterActiveClassSuffix } ${ this.animatedClass }${ enterActiveClassSuffix }`,
          enterToClass: `${ componentAnimatedClass }${ enterToClassSuffix } ${ this.animatedClass }${ enterToClassSuffix }`,
          leaveClass: `${ componentAnimatedClass }${ leaveClassSuffix } ${ this.animatedClass }${ leaveClassSuffix }`,
          leaveActiveClass: `${ componentAnimatedClass }${ leaveActiveClassSuffix } ${ this.animatedClass }${ leaveActiveClassSuffix }`,
          leaveToClass: `${ componentAnimatedClass }${ leaveToClassSuffix } ${ this.animatedClass }${ leaveToClassSuffix }`
        };
      }
    }
  },
  methods: {
    onEnter: function (element: HTMLElement): void {
      const scrollHeight = element.scrollHeight;
      element.style.height = '0';
      requestAnimationFrame(() => {
        element.style.height = `${ scrollHeight }px`;
      });
    },
    onAfterEnter: function (element: HTMLElement): void {
      element.style.height = 'auto';
    },
    onLeave: function (element: HTMLElement): void {
      element.style.height = `${ element.scrollHeight }px`;
      requestAnimationFrame(() => {
        element.style.height = '0';
        element.style.padding = '0';
        element.style.border = '0';
        element.style.margin = '0';
      });
    },
    onAfterLeave: function (element: HTMLElement): void {
      element.style.removeProperty('height');
    }
  }
};

